import { Injectable } from '@angular/core';

import { ArticleAdapter } from '../adapters/article.adapter';
import { PresskitArticleAdapter } from '../adapters/presskit.adapter';
import { RichSnippetAdapter } from '../interface/rich-snippet.interface';

type Adapters = 'article' | 'presskit';

@Injectable({
  providedIn: 'root',
})
export class RichSnippetFactory {
  private adapters = new Map<Adapters, RichSnippetAdapter>([
    ['article', new ArticleAdapter()],
    ['presskit', new PresskitArticleAdapter()],
  ]);

  create(source: Adapters): RichSnippetAdapter {
    return this.adapters.get(source)!;
  }
}
